<template>
  <div class="timeline">
    <div class="header">
      <img :src="iconSrc">
      <span ref="title">{{ title }}</span>
    </div>
    <div class="body">
      <div class="block" v-for="(item, index) in list" :key="index">
        <div class="side">
          <div class="s-node"></div>
          <div class="s-line"></div>
        </div>
        <span class="date">{{ item.date }}</span>
        <a class="content" @click="navTo(item)">{{ item.content }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'timeline',
  props: {
    // [{date: '', content: '', url: ''}, ...]
    iconSrc:{
      type:String
    },
    list: {
      type: Array,
      require: true
    },
    title: {
      type: String,
      required: false,
      default: '最近更新'
    },
    titleColor: {
      type: String,
      required: false,
      default: '#333'
    }
  },
  mounted() {
    this.$refs.title.style.color = this.titleColor
  },
  methods:{
    navTo(item){
      this.$router.push({ path: item.url });
    }
  }
}
</script>

<style lang="scss" scoped>
$node-size: 9px;
$left-space: 30px;
$width: 250px;
  .timeline {
    width: $width;
    .header {
      border-bottom: 3px solid #e3e3e3;
      padding: 5px;
      margin-bottom: 30px;
      font-size: 20px;
      img {
        width: 24px;
        height: 24px;
        margin-right: 20px;
        margin-bottom: -4px;
      }
    }
    .body {
      .block {
        position: relative;
        .side {
          position: absolute;
          width: $node-size;
          left: 5px;
          height: 100%;
          .s-node {
            position: absolute;
            top: 6px;
            box-sizing: border-box;
            width: $node-size;
            height: $node-size;
            background: #fff;
            border: 2px solid #d1d1d1;
            border-radius: 10px;
            z-index: 1;
          }
          .s-line {
            height: calc(100% + 30px);
            width: 2px;
            margin: -10px auto 0 auto;
            background: #eaeaea;
          }
        }
        .date {
          position: relative;
          margin-left: $left-space;
          padding: 4px 8px;
          width: $width - $left-space;
          font-size: 14px;
          background: #fff;
          border: 1Px solid #d1d3d6;
          border-radius: 2Px;
          &::before {
            content: '';
            position: absolute;
            left: -6.5px;
            top: 50%;
            width: 10px;
            height: 10px;
            background: #fff;
            transform: rotate(45deg) translateX(-35.4%) translateY(-35.4%);
            border-left: 1Px solid #d1d3d6;
            border-bottom: 1Px solid #d1d3d6;
            border-radius: 2Px;
          }
        }
        .content {
          display: block;
          margin: 15px 0 25px $left-space;
          width: $width - $left-space;
          cursor: pointer;
          transition: color .1s;
          &:hover {
            color: #000;
          }
        }
      }
    }
  }
</style>